import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  baseUri: string = environment.baseUri;
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  constructor(private http: HttpClient) { }

	// Send an email to the coaches of a new potential member.
  emailPotentialMember(data): Observable<any> {
  	let url = `${this.baseUri}/email/potential-member`;
  	return this.http.post(url, data).pipe(catchError(this.handleError));
  }

  // Send an email to the coaches of a member interested in training.
  scheduleTraining(data): Observable<any> {
    let url = `${this.baseUri}/email/training`;
    return this.http.post(url, data).pipe(catchError(this.handleError));
  }

  // Error Response
  handleError(error: HttpErrorResponse) {
  	return throwError(error);
  }
}
